var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:((_vm.buttonClassName? _vm.buttonClassName: '') + " " + (_vm.darkTheme? 'dark-themed':'light-themed')),attrs:{"disabled":_vm.loading},on:{"click":_vm.clickFunction}},[_c('p',[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }